/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import { isAuthenticated as checkIsAuthenticated } from '../../redux/selectors/auth';

const ProtectedRoute = ({ component: Component, isAuthenticated, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      (isAuthenticated ? (
        <Component {...props} />
      ) : (
        // eslint-disable-next-line react/prop-types
        <Redirect to={{ pathname: '/sign-in', state: { from: props.location } }} />
      ))
    }
  />
);

ProtectedRoute.propTypes = {
  // component: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isAuthenticated: checkIsAuthenticated(state),
  };
}

export default connect(mapStateToProps)(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/components/containers/ProtectedRoute.jsx